import React from 'react';

const GlobalFilter = ({ filter, setFilter, rows }) => {
  return (
    <div className="mt-4 text-white font-mono text-center">
      <span className="text-lg md:text-xl block md:inline-block mb-2">
        Search:{' '}
        <input
          className="text-purple-800 focus:outline-none p-2"
          value={filter || ''}
          onChange={(e) => setFilter(e.target.value)}
        />
      </span>
      <span>
        {' '}
        ({rows.length} {rows.length === 1 ? 'Result' : 'Results'})
      </span>
    </div>
  );
};

export default GlobalFilter;
